import React, { useEffect, useState } from "react";
import logo from "./../../../assets/images/LogoTransparent.png";
import { useNavigate, useSearchParams } from "react-router-dom";
import "./NewUserLogin.css";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import warningImg from "./../../../assets/images/exclamation.png";
import EmployeeRegistrationForm from "../../restaurantsetup/components/EmployeeRegistrationForm/EmployeeRegistrationForm.tsx";

function NewUserLogin(props) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loadedForTheFirstTime, setLoadedForTheFirstTime] = useState(false);
  const [userFound, setUserFound] = useState(false);
  const [passwordNotFound, setPasswordNotFound] = useState(false);
  const [userNameNotFound, setUserNameNotFound] = useState(false);
  const [open, setOpen] = useState(false);

  const apiAddress = process.env.REACT_APP_SECRET;

  const navigate = useNavigate();

  const ProceedLoginusiingAPI = (e) => {
    var approvalUrl = searchParams.get("ri");
    e.preventDefault();
    if (approvalId != undefined) {
      var url =
        apiAddress +
        "/api/AdminLogin/loginfornewuser?userName=" +
        username +
        "&password=" +
        password +
        "&approvalId=" +
        approvalUrl;

      axios({
        method: "post",
        url: url,
      })
        .then(function (response) {
          console.log(response);
          console.log("Data: " + response.data.token);
          localStorage.setItem("gotasteadmintoken", response.data.token);
          // navigate("/" + returnUrl)
          window.location.href = "/";
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.status == 404) {
            console.log(
              "error.response.data.status: " + error.response.data.status
            );
            if (error.response.data.status == "Password not found") {
              setPasswordNotFound(true);
            } else if (error.response.data.status == "Not activated") {
              toast.error("Not Activated", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
              });
            } else if (error.response.data.status == "Email not verified") {
              toast.error("Please verify your email", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
              });
            } else if (
              error.response.data.status == "Link already use by another user"
            ) {
              toast.error("Link already used by another user", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
              });
            } else if (
              error.response.data.status ==
              "Admin cancel or deactivated your account"
            ) {
              toast.error("Admin cancel or deactivated your account", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
              });
            } else {
              toast.error(error.response.data.status, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
              });
            }
          }
          if (error.response.status == 401) {
            setUserNameNotFound(true);
          }
        });
    } else {
      toast.error("Id not found.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };
  const [searchParams, setSearchParams] = useSearchParams();
  const [returnUrl, setReturnUrl] = useState();
  const [approvalId, setApprovalId] = useState();
  useEffect(() => {
    var url = searchParams.get("ri");
    if (url != undefined) {
      // console.log("url: " + url);
      // setReturnUrl(url);
      // // var res = url?.split("=");
      // console.log("res: " + res[1]);
      console.log(url);
      if (url != undefined && url != "undefined") {
        setApprovalId(url);
        // loadData(res[1]);
      } else {
        toast.error("Id not found.", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        window.location.href = "/login";
      }
    } else {
      toast.error("Url not found", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      // window.location.href = "/login";
    }
  }, []);

  const [isAccountAlreadyCreated, setIsAccountAlreadyCreated] = useState(false);
  // const loadData = (props) => {

  //     axios
  //         .get(apiAddress + "/api/KYCForm/verifyUserRegistrationForKycForm/" + props)
  //         .then((response) => {
  //             console.log(response.data);

  //             if (response.data == "NoUserUseThisLink") {

  //             }
  //             else {
  //                 setIsAccountAlreadyCreated(true);
  //             }

  //         });
  // }
  const modalOpen = () => {
    setOpen(true);
  };
  const modalClose = (data) => {
    setOpen(data);
  };

  return (
    <div style={{ height: "100vh" }}>
      <ToastContainer />
      <EmployeeRegistrationForm open={open} modalClose={modalClose} />
      <div className="divClass"></div>

      <div className="container login  d-flex align-items-center justify-content-center h-100">
        <form
          onSubmit={ProceedLoginusiingAPI}
          className="custom-loginForm loginCardKYC"
        >
          <div className="container ">
            <div className="d-flex justify-content-center">
              <img
                src={logo}
                alt=""
                style={{ width: "6.5rem", marginBottom: "1rem" }}
              />
            </div>
            <h5 className="goTasteH3 d-flex justify-content-center">
              Welcome To GoTaste Admin Panel
            </h5>
            <div className={"row mt-3 "}>
              <div className="col-12">
                <div className="form-group ">
                  <input
                    type="text"
                    className="form-control login-info"
                    value={username}
                    placeholder="Enter Email / User Name"
                    onChange={(event) => {
                      setUsername(event.target.value);
                    }}
                  />
                  <span
                    className={`${userNameNotFound ? "" : "d-none"}`}
                    style={{ color: "red", fontSize: ".8rem" }}
                  >
                    {" "}
                    Enter Email / User Name not found *
                  </span>
                </div>
              </div>
            </div>
            <div className={"row mt-2 "}>
              <div className="col-12">
                <div className="form-group ">
                  <input
                    type="password"
                    className="form-control login-info"
                    value={password}
                    placeholder="Password"
                    onChange={(event) => {
                      setPassword(event.target.value);
                    }}
                  />
                  <span
                    className={`${passwordNotFound ? "" : "d-none"}`}
                    style={{ color: "red", fontSize: ".8rem" }}
                  >
                    {" "}
                    Password not matched *
                  </span>
                </div>
              </div>
            </div>
            <div className={"row mt-2 "}>
              <div className="col-12">
                <span className="text-muted span-text">
                  You can use your existing GoTaste account to login
                </span>
              </div>
            </div>
            <div className={"row mt-4 "}>
              <div className="col-12 d-flex justify-content-center">
                <button
                  className="btn btn-success font-weight-bold w-100 "
                  style={{ width: "    width: 100%;", borderRadius: "8px" }}
                  type="submit"
                >
                  Login
                </button>
              </div>
            </div>

            <div className={"row mt-2 "}>
              <div className="col-12 d-flex justify-content-between">
                <span className="text-muted span-text">
                  Don't have any account?
                </span>
                <span
                  className="span-text"
                  style={{ color: "blue", cursor: "pointer" }}
                  onClick={modalOpen}
                >
                  Create account
                </span>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default NewUserLogin;
